import { selectDoc, event, addClass, removeClass } from "../utils/utils";
import { createFocusTrap } from "focus-trap";
export class SidePanels {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.openMenuButton = selectDoc("[data-open-menu]");
    this.closeMenuButton = selectDoc("[data-close-menu]");
    this.menuContainer = selectDoc("[data-menu-panel]");
    this.html = selectDoc("html");
    this.openCartButton = selectDoc("[data-open-cart]");
    this.closeCartButton = selectDoc("[data-close-cart]");
    this.cartContainer = selectDoc("[data-cart-panel]");
  }

  render() {
    this.panelToggle(
      this.menuContainer,
      this.openMenuButton,
      this.closeMenuButton
    );
    this.panelToggle(
      this.cartContainer,
      this.openCartButton,
      this.closeCartButton
    );
  }

  panelToggle = (container, open, close) => {
    const focusTrap = createFocusTrap(container, {
      onActivate: () => panelOpen(),
      onDeactivate: () => panelClose(),
    });

    const panelOpen = () => {
      addClass(container, "active");
      addClass(this.html, "overflow-hidden");
      open === this.openMenuButton ? selectDoc('.section-header').classList.add('menu-opened'):null;
    };

    const panelClose = () => {
      removeClass(container, "active");
      removeClass(this.html, "overflow-hidden");
      open === this.openMenuButton ? selectDoc('.section-header').classList.remove('menu-opened'):null;
    };

    if (open) {
      event(open, "click", focusTrap.activate);
    }

    if (close) {
      event(close, "click", focusTrap.deactivate);
    }
  };
}
